export default function() {
  return {
    widthMeasures: [],
    heightMeasures: [],
    rimMeasures: []
  }
}
